// extracted by mini-css-extract-plugin
export default {"card":"CheckoutSummary_card__XX6w3","text":"CheckoutSummary_text__dbWJj"};